import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { hasReportsAccess } from '@app/utils/cognitoAuth';

const AuthCallback: React.FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');

        if (!code) {
          throw new Error('No authorization code received');
        }

        // Exchange the authorization code for tokens
        const { tokens } = await fetchAuthSession();

        // Verify the user is authenticated
        const user = await getCurrentUser();

        // Check if user has access to reports
        const hasAccess = await hasReportsAccess();
        if (!hasAccess) {
          navigate('/unauthorized', { replace: true });
          return;
        }
        
        // Redirect to reports page after successful authentication and permission check
        navigate('/reports', { replace: true });
      } catch (error) {
        console.error('Authentication error:', error);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [location, navigate]);

  return null; // or a loading spinner
};

export { AuthCallback }; 